var _style, _path, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 388.5 507",
    style: {
      enableBackground: "new 0 0 388.5 507"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#F7B93F;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#507E1A;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#8B572A;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M192.5,5l7,14.4l15.8,2.2l-11.5,11.1l2.8,15.7l-14.1-7.6l-14.1,7.5l2.8-15.7l-11.5-11.1l15.8-2.2L192.5,5z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    className: "st1",
    points: "192.5,50.6 285.9,144 99.1,144 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle_1_",
    className: "st1",
    points: "192.5,54.8 311.5,203.4 73.5,203.4 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle_4_",
    className: "st1",
    points: "192.5,74 327.5,262.8 57.5,262.8 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle_2_",
    className: "st1",
    points: "192.5,54.8 344.5,322.2 40.5,322.2 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle_3_",
    className: "st1",
    points: "192.5,193 385,441 0,441 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle_5_",
    className: "st1",
    points: "192.5,119 362.2,381.6 22.8,381.6 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 165,
    y: 441,
    className: "st2",
    width: 55,
    height: 66
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTree);
export default __webpack_public_path__ + "static/media/tree.2536b5e16256287349d2feb5151b07da.svg";
export { ForwardRef as ReactComponent };